import { ApiProperty } from "@nestjs/swagger";
import { IsAlphanumeric, IsNotEmpty, IsOptional, Matches, MaxLength } from "class-validator";

export class VendorItemRequestDto{
  @ApiProperty()
  @IsNotEmpty()
  vendorId: number;
  @ApiProperty()
  @IsNotEmpty()
  itemId: number;
}